module.exports = { id: "radius", url: "/build/app/img/symbols.svg#radius", viewBox: "", toString: function() { return this.url; } };